import { Tab } from "semantic-ui-react";
import CollectionPeriod from "./CollectionPeriod";
import React from "react";
import InterimCollections from "./InterimCollections";

const PrimaryTabs = ({ loadData, onDetailsRowClick }) => {
  const panes = [
    {
      menuItem: "Summary",
      pane: (
        <Tab.Pane>
          <CollectionPeriod loadData={loadData} allowShowMeters={true} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Count Details",
      pane: (
        <Tab.Pane>
          <InterimCollections onDetailsRowClick={onDetailsRowClick} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Tab
      renderActiveOnly={false}
      panes={panes}
      className="flex-stretch gs-flex-container-vertical h-60"
    />
  );
};

export default PrimaryTabs;
